import googledrive_controller from './googledrive_controller' 
import dropbox_controller from './dropbox_controller'  

export default {
  data () {
    return {
      filtro: {}
    }
  },
  methods: {

    googleDriveLogin (client_id) {

      var result = {}

      try {

        return new Promise((resolve, reject) => {

          googledrive_controller.openAuth(client_id, function (authResult) {

            if (authResult.error) {
              if (authResult.details) {
                result.error = authResult.details
              } else {
                result.error = authResult.error
              }

              resolve({
                result
              })
            } else {

              if (authResult.code) { //access_token
                result = authResult
                resolve({
                  result
                })
              } else {
                result.error = "Error en la autenticación"
                resolve({
                  result
                })
              } 
            } 

          })
    
        })

      } catch (error) {
        result.error = "Error en la autenticación"
        resolve({
          result
        })
      }

    },

    getImgUrl (mimeType) {
      var images = require.context('../../../assets/images/mimeTypes/', false, /\.png$/)
      if (mimeType == "image/jpeg" || mimeType == "image/png") {
        return images("./img.png")
      } else if (mimeType == "application/pdf") {
        return images("./pdf.png")
      } else if (mimeType == "application/vnd.openxmlformats-officedocument.wordprocessingml.document"){
        return images("./word.png")
      } else if (mimeType == "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet"){
        return images("./excel.png")
      } else if (mimeType == "text/plain"){
        return images("./txt.png")
      } else {
        return images("./file.png")
      }
    },

    Repository_NewProjectFile (proyecto_tarea_documento_version) {

      var result = {}

      try {

        return new Promise((resolve, reject) => {

          this.getTokenPorRepositorio(proyecto_tarea_documento_version.v2_empresa_id)
          .then(data => {

            if (data.result.error) {
              result.error = data.result.error
              resolve({
                result
              })
            } else {
              if (data.result.tipo == 'googledrive') {

                googledrive_controller.openPicker(data.result.current_token, proyecto_tarea_documento_version.folder_path, function (uploadResult) {
                  if (uploadResult) {
                    if (uploadResult.action) {
                      if (uploadResult.action == 'picked') {

                        if (uploadResult.docs != undefined) {
                          if (uploadResult.docs.length > 0) {
                            uploadResult.docs.forEach(doc => {
                
                              if (doc.uploadState == 'success') {
                                result.id = doc.id
                                result.name = doc.name
                                result.mimeType = doc.mimeType
                                result.type = doc.type
                                result.iconUrl = doc.iconUrl
                                result.url = doc.url
                                result.downloadUrl = doc.downloadUrl
                              } 
                              
                            });
                          }
                        }

                        result.status = uploadResult.action
                        uploadResult
                        resolve({
                          result
                        })

                      } else if (uploadResult.action == 'cancel') {

                        result.status = uploadResult.action
                        resolve({
                          result
                        })

                      }
                    }
                  }
                })

              } else if (data.result.drive_config.tipo == 'onedrive') {

              } else if (data.result.drive_config.tipo == 'dropbox') {

                dropbox_controller.openPicker(data.result.current_token, proyecto_tarea_documento_version.folder_path, function (uploadResult) {

                  console.log(uploadResult)

                })

              } else if (data.result.drive_config.tipo == 'filenet') {

              } else if (data.result.drive_config.tipo == 'awsftp') {

              } else if (data.result.drive_config.tipo == 'ftp') {

              } else if (data.result.drive_config.tipo == 'sftp') {

              } else {
                result.error = "No se encontró una configuración de repositorio para el grupo de trabajo"
                resolve({
                  result
                })
              }
            }
                      
          })

        })

      } catch (error) {
        result.error = "No se encontró una configuración de repositorio para el grupo de trabajo"
        resolve({
          result
        })
      }

    },
    Repository_UpdateProjectFile (proyecto_tarea_documento_version) {

      var result = {}

      try {

        return new Promise((resolve, reject) => {

          this.getTokenPorRepositorio(proyecto_tarea_documento_version.v2_empresa_id)
            .then(data => {

              if (data.result.error) {
                result.error = data.result.error
                resolve({
                  result
                })
              } else {
                if (data.result.tipo == 'googledrive') {

                  googledrive_controller.openPicker(data.result.current_token, proyecto_tarea_documento_version.folder_path, function (uploadResult) {
                    if (uploadResult) {
                      if (uploadResult.action) {
                        if (uploadResult.action == 'picked') {

                          if (uploadResult.docs != undefined) {
                            if (uploadResult.docs.length > 0) {
                              uploadResult.docs.forEach(doc => {
                  
                                if (doc.uploadState == 'success') {
                                  result.id = doc.id
                                  result.name = doc.name
                                  result.mimeType = doc.mimeType
                                  result.type = doc.type
                                  result.iconUrl = doc.iconUrl
                                  result.url = doc.url
                                  result.downloadUrl = doc.downloadUrl
                                } 
                                
                              });
                            }
                          }

                          result.status = uploadResult.action
                          uploadResult
                          resolve({
                            result
                          })

                        } else if (uploadResult.action == 'cancel') {

                          result.status = uploadResult.action
                          resolve({
                            result
                          })

                        }
                      }
                    }
                  })

                } else if (data.result.drive_config.tipo == 'onedrive') {

                } else if (data.result.drive_config.tipo == 'dropbox') {

                } else if (data.result.drive_config.tipo == 'filenet') {

                } else if (data.result.drive_config.tipo == 'awsftp') {

                } else if (data.result.drive_config.tipo == 'ftp') {

                } else if (data.result.drive_config.tipo == 'sftp') {

                } else {
                  result.error = "No se encontró una configuración de repositorio para el grupo de trabajo"
                  resolve({
                    result
                  })
                }
              }
                        
            })

        })

      } catch (error) {
        result.error = "No se encontró una configuración de repositorio para el grupo de trabajo"
        resolve({
          result
        })
      }

    },
    Repository_DownloadProjectFile (proyecto_tarea_documento_version) {

      var result = {}

      try {

        return new Promise((resolve, reject) => {

          this.getTokenPorRepositorio(proyecto_tarea_documento_version.v2_empresa_id)
            .then(data => {

              if (data.result.error) {
                result.error = data.result.error
                resolve({
                  result
                })
              } else {
                if (data.result.tipo == 'googledrive') {

                  this.$http.plain.get('https://www.googleapis.com/drive/v2/files/' + proyecto_tarea_documento_version.file_id, {
                      headers: {'Authorization': 'Bearer ' + data.result.current_token}
                    })
                      .then(response => {

                        if (response.data.downloadUrl) {
                          var xhr = new XMLHttpRequest();
                          xhr.open('GET', response.data.downloadUrl);
                          xhr.setRequestHeader('Authorization', 'Bearer ' + data.result.current_token);
                          xhr.responseType = 'blob';
                          xhr.onload = function(e) {

                            if (this.status == 200) {

                              var blob = this.response;

                              var a = document.createElement("a");
                              document.body.appendChild(a);
                              a.style = "display: none";

                              var url_download = window.URL.createObjectURL(blob);
                              
                              a.href = url_download;
                              a.download = proyecto_tarea_documento_version.file_name;
                              a.click();
                              window.URL.revokeObjectURL(url_download);

                              result.status = "download"
                              resolve({
                                result
                              })

                            }
                          };
                          xhr.onerror = function() {
                            result.error = "No se pudo descargar el documento"
                            resolve({
                              result
                            })
                          };
                          xhr.send();
                        }

                      })
                      .catch(error => {
                        result.error = "No se pudo descargar el documento"
                        resolve({
                          result
                        })
                      })

                
                } else if (data.result.drive_config.tipo == 'onedrive') {

                } else if (data.result.drive_config.tipo == 'dropbox') {

                } else if (data.result.drive_config.tipo == 'filenet') {

                } else if (data.result.drive_config.tipo == 'awsftp') {

                } else if (data.result.drive_config.tipo == 'ftp') {

                } else if (data.result.drive_config.tipo == 'sftp') {

                } else {
                  result.error = "No se encontró una configuración de repositorio para el grupo de trabajo"
                  resolve({
                    result
                  })
                }
              }
                        
            })

        })

      } catch (error) {
        result.error = "No se encontró una configuración de repositorio para el grupo de trabajo"
        resolve({
          result
        })
      }

    },
    getTokenPorRepositorio (v2_empresa_id) {

      var result = {}

      try {

        return new Promise((resolve, reject) => {

          this.$http.secured.get('/global/v1/v2_repositorios/', { params: { type: "getTokenPorRepositorio", v2_empresa_id: v2_empresa_id } })
            .then(response => {

              if (response) {
                if (response.data) {
                  result.tipo = response.data.tipo
                  result.current_token = response.data.current_token
                } else {
                  result.error = "No se encontró una configuración de repositorio para el grupo de trabajo"
                }
              } else {
                result.error = "No se encontró una configuración de repositorio para el grupo de trabajo"
              }

              resolve({
                result
              })
            })
            .catch(error => {
              result.error = error
              resolve({
                result
              })
            })  
        
        })
      } catch (error) {
        result.error = error
        resolve({
          result
        })
      }
    },

    Repository_NewCaseFile (caso) {

      var result = {}

      try {

        return new Promise((resolve, reject) => {

          this.getTokenPorRepositorio(caso.v2_empresa_id)
          .then(data => {

            if (data.result.error) {
              result.error = data.result.error
              resolve({
                result
              })
            } else {
              if (data.result.tipo == 'googledrive') {

                googledrive_controller.openPicker(data.result.current_token, caso.folder_path, function (uploadResult) {
                  if (uploadResult) {
                    if (uploadResult.action) {
                      if (uploadResult.action == 'picked') {

                        if (uploadResult.docs != undefined) {
                          if (uploadResult.docs.length > 0) {
                            uploadResult.docs.forEach(doc => {

                              if (doc.uploadState == 'success') {
                                result.id = doc.id
                                result.name = doc.name
                                result.mimeType = doc.mimeType
                                result.type = doc.type
                                result.iconUrl = doc.iconUrl
                                result.url = doc.url
                                result.downloadUrl = doc.downloadUrl
                              } 
                              
                            });
                          }
                        }

                        result.status = uploadResult.action
                        uploadResult
                        resolve({
                          result
                        })

                      } else if (uploadResult.action == 'cancel') {

                        result.status = uploadResult.action
                        resolve({
                          result
                        })

                      }
                    }
                  }
                })

              } else if (data.result.drive_config.tipo == 'onedrive') {

              } else if (data.result.drive_config.tipo == 'dropbox') {

              } else if (data.result.drive_config.tipo == 'filenet') {

              } else if (data.result.drive_config.tipo == 'awsftp') {

              } else if (data.result.drive_config.tipo == 'ftp') {

              } else if (data.result.drive_config.tipo == 'sftp') {

              } else {
                result.error = "No se encontró una configuración de repositorio para el grupo de trabajo"
                resolve({
                  result
                })
              }
            }
                      
          })

        })

      } catch (error) {
        result.error = "No se encontró una configuración de repositorio para el grupo de trabajo"
        resolve({
          result
        })
      }

    },
    Repository_UpdateCaseFile (caso) {

      var result = {}

      try {

        return new Promise((resolve, reject) => {

          this.getTokenPorRepositorio(caso.v2_empresa_id)
            .then(data => {

              if (data.result.error) {
                result.error = data.result.error
                resolve({
                  result
                })
              } else {
                if (data.result.tipo == 'googledrive') {

                  googledrive_controller.openPicker(data.result.current_token, caso.folder_path, function (uploadResult) {
                    if (uploadResult) {
                      if (uploadResult.action) {
                        if (uploadResult.action == 'picked') {

                          if (uploadResult.docs != undefined) {
                            if (uploadResult.docs.length > 0) {
                              uploadResult.docs.forEach(doc => {
                  
                                if (doc.uploadState == 'success') {
                                  result.id = doc.id
                                  result.name = doc.name
                                  result.mimeType = doc.mimeType
                                  result.type = doc.type
                                  result.iconUrl = doc.iconUrl
                                  result.url = doc.url
                                  result.downloadUrl = doc.downloadUrl
                                } 
                                
                              });
                            }
                          }

                          result.status = uploadResult.action
                          uploadResult
                          resolve({
                            result
                          })

                        } else if (uploadResult.action == 'cancel') {

                          result.status = uploadResult.action
                          resolve({
                            result
                          })

                        }
                      }
                    }
                  })

                } else if (data.result.drive_config.tipo == 'onedrive') {

                } else if (data.result.drive_config.tipo == 'dropbox') {

                } else if (data.result.drive_config.tipo == 'filenet') {

                } else if (data.result.drive_config.tipo == 'awsftp') {

                } else if (data.result.drive_config.tipo == 'ftp') {

                } else if (data.result.drive_config.tipo == 'sftp') {

                } else {
                  result.error = "No se encontró una configuración de repositorio para el grupo de trabajo"
                  resolve({
                    result
                  })
                }
              }
                        
            })

        })

      } catch (error) {
        result.error = "No se encontró una configuración de repositorio para el grupo de trabajo"
        resolve({
          result
        })
      }

    },
    Repository_DownloadCaseFile (documento_version) {

      var result = {}

      try {

        return new Promise((resolve, reject) => {

          this.getTokenPorRepositorio(documento_version.v2_empresa_id)
            .then(data => {

              if (data.result.error) {
                result.error = data.result.error
                resolve({
                  result
                })
              } else {
                if (data.result.tipo == 'googledrive') {

                  this.$http.plain.get('https://www.googleapis.com/drive/v2/files/' + documento_version.file_id, {
                      headers: {'Authorization': 'Bearer ' + data.result.current_token}
                    })
                      .then(response => {

                        if (response.data.downloadUrl) {
                          var xhr = new XMLHttpRequest();
                          xhr.open('GET', response.data.downloadUrl);
                          xhr.setRequestHeader('Authorization', 'Bearer ' + data.result.current_token);
                          xhr.responseType = 'blob';
                          xhr.onload = function(e) {

                            if (this.status == 200) {

                              var blob = this.response;

                              var a = document.createElement("a");
                              document.body.appendChild(a);
                              a.style = "display: none";

                              var url_download = window.URL.createObjectURL(blob);
                              
                              a.href = url_download;
                              a.download = documento_version.file_name;
                              a.click();
                              window.URL.revokeObjectURL(url_download);

                              result.status = "download"
                              resolve({
                                result
                              })

                            }
                          };
                          xhr.onerror = function() {
                            result.error = "No se pudo descargar el documento"
                            resolve({
                              result
                            })
                          };
                          xhr.send();
                        }

                      })
                      .catch(error => {
                        result.error = "No se pudo descargar el documento"
                        resolve({
                          result
                        })
                      })

                
                } else if (data.result.drive_config.tipo == 'onedrive') {

                } else if (data.result.drive_config.tipo == 'dropbox') {

                } else if (data.result.drive_config.tipo == 'filenet') {

                } else if (data.result.drive_config.tipo == 'awsftp') {

                } else if (data.result.drive_config.tipo == 'ftp') {

                } else if (data.result.drive_config.tipo == 'sftp') {

                } else {
                  result.error = "No se encontró una configuración de repositorio para el grupo de trabajo"
                  resolve({
                    result
                  })
                }
              }
                        
            })

        })

      } catch (error) {
        result.error = "No se encontró una configuración de repositorio para el grupo de trabajo"
        resolve({
          result
        })
      }

    },

  }
};